module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', [_vm._v("PRIVACY POLICY")])]), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "rte"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "custom-content"
  }, [_c('div', {
    staticClass: "custom__item custom__item--1537787486018 one-whole align--center"
  }, [_c('div', {
    staticClass: "medium-up--text-center"
  }, [_c('p', {
    attrs: {
      "data-custom-class": "title"
    }
  }, [_c('b', [_c('strong', [_vm._v(" PRIVACY NOTICE ")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "data-custom-class": "title"
    }
  }, [_c('b', [_c('strong', [_vm._v(" Last updated August 26, 2020 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rte-setting"
  }, [_c('p', [_vm._v("\nThank you for choosing to be part of our community at Lilpicks, doing business as “we”, “us”, or “our”. We are committed to protecting your personal information and your right to privacy. If\nyou have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please contact us at info@majesticbookclub.com.\n")]), _vm._v("\nWhen you visit our website https://lilpicks.com/ (the \"Website\"), and more generally, use any of our services (the \"Services\", which include the Website), we appreciate that you are trusting\nus with your personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you in the clearest way possible what information we collect, how we use it\nand what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy notice that you do not agree with,\nplease discontinue use of our Services immediately.\n"), _c('p', [_vm._v("\nThis privacy notice applies to all information collected through our Services (which, as described above, includes our Website), as well as any related services, sales, marketing or events.\nIn 2020, We started catering worldwide and Successful Delivered Orders to Singapore, Malaysia and Dubai.\n  ")]), _c('p', {
    attrs: {
      "data-custom-class": "title"
    }
  }, [_c('b', [_c('strong', [_vm._v(" Please read this privacy notice carefully as it will help you understand what we do with the information that we collect. ")])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "data-custom-class": "title"
    }
  }, [_c('b', [_c('strong', [_vm._v(" TABLE OF CONTENTS ")])])]), _vm._v(" \n1.WHAT INFORMATION DO WE COLLECT?\n2.HOW DO WE USE YOUR INFORMATION?\n3.WILL YOUR INFORMATION BE SHARED WITH ANYONE?\n4. HOW DO WE HANDLE YOUR SOCIAL LOGINS?\n5.HOW LONG DO WE KEEP YOUR INFORMATION?\n6.HOW DO WE KEEP YOUR INFORMATION SAFE?\n7.WHAT ARE YOUR PRIVACY RIGHTS?\n8.CONTROLS FOR DO-NOT-TRACK FEATURES\n9.DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?\n10.DO WE MAKE UPDATES TO THIS NOTICE?\n11.HOW CAN YOU CONTACT US ABOUT THIS NOTICE?\n"), _c('br'), _vm._v(" "), _c('br')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72e447ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/privacyPolicy.vue
// module id = 2313
// module chunks = 0